import { z } from 'zod';

export const TabSchema = z.object({
    id: z.string(),
    display: z.string(),
    value: z.string(),
    data: z.any().optional(),
    disabled: z.boolean().optional(),
});
export const TabValueSchema = z.object({
    value: z.string(),
});

export const TabArraySchema = z.array(TabSchema);

export type Tab = z.infer<typeof TabSchema>;

export function isTab(obj: any): obj is Tab {
    return TabSchema.safeParse(obj).success;
}

export const emptyTab: Tab = {
    id: '',
    display: '',
    value: '',
    data: undefined,
    disabled: false,
};

export interface IIqControlTabStateService {}
